module.exports = __webpack_public_path__ + "components/forecast-table/tooltips/static/snowfall-ba9db4207cefd46447bdb4097c44b236.jpg";